import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const localDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

// Counts real listening time and reports it in ≤60 s chunks; a day ticks at 5 minutes.
export const useListenDays = (audioRef, jid, initialDays, active) => {
  const [days, setDays] = useState(initialDays || 0);
  const pending = useRef(0);
  const last = useRef(null);
  useEffect(() => {
    const a = audioRef.current;
    if (!a || !active) return undefined;
    const flush = () => {
      const s = Math.floor(pending.current);
      if (s < 1) return;
      pending.current -= s;
      axios.post(`${API}/api/audio-journeys/${jid}/listen`, { seconds: Math.min(s, 120), local_date: localDate(), local_hour: new Date().getHours() }, auth())
        .then((r) => { setDays(r.data.listen_days_count); if (r.data.practice_credited) window.dispatchEvent(new Event("soulumo:practice")); }).catch(() => {});
    };
    const onTime = () => {
      const t = a.currentTime;
      if (last.current != null && !a.paused) {
        const dt = t - last.current;
        if (dt > 0 && dt < 3) pending.current += dt;
      }
      last.current = t;
      if (pending.current >= 60) flush();
    };
    const onStop = () => { last.current = null; flush(); };
    a.addEventListener("timeupdate", onTime);
    a.addEventListener("pause", onStop);
    a.addEventListener("ended", onStop);
    return () => {
      flush();
      a.removeEventListener("timeupdate", onTime);
      a.removeEventListener("pause", onStop);
      a.removeEventListener("ended", onStop);
    };
  }, [audioRef, jid, active]);
  return days;
};
